import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  TextField,
  useTheme,
} from '@mui/material';
import { useState } from 'react';
import { useAppDispatch } from '../../../../app/hooks';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';
import { flexCenter } from '../../../commonUI/cssClasses';
import useFilterScanData, {
  ScanDataFilterEnum,
} from '../../../scanDataApi/hooks/useFilterScanData';
import { setMapMeasurePoint1, setMapMeasurePoint2 } from '../../mapSlice';

const SetPointsByID: React.FC = () => {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const [point1ID, setPoint1ID] = useState<string>('');
  const [point2ID, setPoint2ID] = useState<string>('');

  const scanDataPoint1 = useFilterScanData({
    activeFilters: [ScanDataFilterEnum.point_id],
    customPointId: point1ID,
  });

  const scanDataPoint2 = useFilterScanData({
    activeFilters: [ScanDataFilterEnum.point_id],
    customPointId: point2ID,
  });

  const handleSetPoint1 = () => {
    if (
      scanDataPoint1 &&
      scanDataPoint1.data &&
      scanDataPoint1?.data.length > 0
    ) {
      dispatch(setMapMeasurePoint1(scanDataPoint1.data[0]));
    } else {
      dispatch(setMapMeasurePoint1(null));
      alert(t('Point not found.', { ns: 'ranch-view' }));
    }
  };

  const handleSetPoint2 = () => {
    if (
      scanDataPoint2 &&
      scanDataPoint2.data &&
      scanDataPoint2?.data.length > 0
    ) {
      dispatch(setMapMeasurePoint2(scanDataPoint2.data[0]));
    } else {
      dispatch(setMapMeasurePoint2(null));
      alert(t('Point not found.', { ns: 'ranch-view' }));
    }
  };

  return (
    <Box sx={{ width: '100%', mb: '1rem' }}>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: 'white' }} />}
          aria-controls='panel1-content'
          id='panel1-header'
        >
          Optional: Set Points By ID Instead
        </AccordionSummary>
        <AccordionDetails>
          <Box sx={{ width: '100%', ...flexCenter }}>
            <TextField
              label='Point ID 1'
              variant='filled'
              size='small'
              fullWidth
              value={point1ID}
              onChange={(e) => setPoint1ID(e.target.value)}
            />
            <Button
              variant='contained'
              sx={{
                whiteSpace: 'nowrap',
                ml: '1rem',
                bgcolor: theme.colors.darkTheme.teal,
                '&:hover': {
                  bgcolor: `${theme.colors.darkTheme.teal}`,
                  opacity: 0.8,
                },
              }}
              onClick={handleSetPoint1}
            >
              Set Point 1
            </Button>
          </Box>
          <Box sx={{ width: '100%', ...flexCenter, mt: '1rem' }}>
            <TextField
              label='Point ID 2'
              variant='filled'
              size='small'
              fullWidth
              value={point2ID}
              onChange={(e) => setPoint2ID(e.target.value)}
            />
            <Button
              variant='contained'
              sx={{
                whiteSpace: 'nowrap',
                ml: '1rem',
                bgcolor: theme.colors.darkTheme.purple,
                '&:hover': {
                  bgcolor: `${theme.colors.darkTheme.purple}`,
                  opacity: 0.8,
                },
              }}
              onClick={handleSetPoint2}
            >
              Set Point 2
            </Button>
          </Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default SetPointsByID;
